import { render, staticRenderFns } from "./document_extraction_parameters.vue?vue&type=template&id=76d0a956&scoped=true"
import script from "./document_extraction_parameters.vue?vue&type=script&lang=js"
export * from "./document_extraction_parameters.vue?vue&type=script&lang=js"
import style0 from "./document_extraction_parameters.vue?vue&type=style&index=0&id=76d0a956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d0a956",
  null
  
)

export default component.exports